import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HeaderModule } from '../shared/header/header.module';
import { FooterModule } from '../shared/footer/footer.module';
import { SearchContentModule } from '../shared/search/search.module';
import { LoginModule } from '../shared/transact-auth/transact-auth.module';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCaretLeft, faCaretRight, faSync, faTimes } from '@fortawesome/free-solid-svg-icons';
import { LandingComponent } from './landing.component';
import { StreamsSideListModule } from '../shared/streams-side-list/streams-side-list.module';
import { CategorySelectorModule } from '../shared/category-selector/category-selector.module';
import { CreateNoteModule } from '../shared/create-note-component/create-note.module';
import { ImgLazyLoadingModule } from '../shared/image-lazy-loading/image-lazy-loading.module';
import { NotdPartnersModalModule } from '../shared/notd-partners-modal/notd-partners-modal.module';
import { ReadMoreFromNotesModule } from '../shared/read-more-from-notes/read-more-from-notes.module';
import { FeaturedNotesModule } from './featured-notes/featured-notes.module';

@NgModule({
    declarations: [ LandingComponent ],
    imports: [
        RouterModule.forChild([{ path: '', component: LandingComponent }]),
        FooterModule,
        HeaderModule,
        CommonModule,
        SearchContentModule,
        LoginModule,
        StreamsSideListModule,
        CategorySelectorModule,
        FontAwesomeModule,
        CreateNoteModule,
        ImgLazyLoadingModule,
        NotdPartnersModalModule,
        ReadMoreFromNotesModule,
        FeaturedNotesModule
    ],
    exports: [ LandingComponent ]
})

export class LandingModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(faTimes, faSync, faCaretLeft, faCaretRight);
  }
}
